import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewValidadorCaravana = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'valida_excel',
        name: 'Validador de Caravana',
        component: ViewValidadorCaravana,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
